import { PageContent } from "@app/informative-pages/components";
import { getPageService } from "@core/informative-pages/services";
import { PageResponseData } from "@core/informative-pages/types";
import { getLoaderEndpoint, pageHead } from "@framework/config/drivers";
import { trans } from "@mongez/localization";
import { LoaderFunctionArgs } from "@remix-run/node";
import { useLoaderData } from "@remix-run/react";

export async function loader({ request }: LoaderFunctionArgs) {
  const { http, success, catchErrors } = await getLoaderEndpoint(request);

  try {
    const res = await getPageService(http, "return-policy");

    return success(res);
  } catch (error) {
    return catchErrors(error);
  }
}

export default function PrivacyPolicy() {
  const { page } = useLoaderData<PageResponseData>();

  return <PageContent page={page} />;
}

export function meta() {
  return pageHead({
    title: trans("returnPolicy"),
    appendAppName: true,
  });
}
